import React from "react";
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Typography, Button, IconButton, Box 
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function BlockchainGameGuideModal({ open, onClose }) {
    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "14px",
                    p: 0.5,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
                }
            }}
        >
            <DialogTitle 
                sx={{ 
                    m: 0, 
                    p: 2, 
                    textAlign: "center", 
                    fontWeight: 700, 
                    fontSize: "18px", 
                    color: "#0f172a", 
                    position: "relative" 
                }}
            >
                Hướng dẫn chi tiết
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 12,
                        top: 12,
                        color: "#64748b",
                        "&:hover": { color: "#0f172a", bgcolor: "rgba(0,0,0,0.04)" }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{ borderTop: "1px solid #e2e8f0", borderBottom: "none", px: 3, py: 2.5 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    
                    {/* Tỉ lệ */}
                    <Box>
                        <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0f172a", mb: 0.5 }}>
                            Tỉ lệ
                        </Typography>
                        <Box component="ul" sx={{ pl: 2.5, m: 0, color: "#334155", fontSize: "13.5px", lineHeight: 1.6 }}>
                            <Box component="li" sx={{ mb: 0.5 }}>
                                Là số điểm người chơi nhận được sẽ tương ứng với tỷ lệ đặt ra cho mỗi 1 đơn vị điểm cược.
                            </Box>
                            <Box component="li">
                                Ví dụ: Ô [Chẵn] tỷ lệ là 1.996. Nếu người chơi đặt cược 100.000 VNĐ vào [Chẵn] và thắng, người chơi sẽ nhận được 100.000 VNĐ × 1.996 = 199.600 VNĐ (bao gồm cả điểm cược ban đầu và điểm thắng).
                            </Box>
                        </Box>
                    </Box>

                    {/* Lịch sử phiên */}
                    <Box>
                        <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0f172a", mb: 0.5 }}>
                            Lịch sử phiên
                        </Typography>
                        <Box component="ul" sx={{ pl: 2.5, m: 0, color: "#334155", fontSize: "13.5px", lineHeight: 1.6 }}>
                            <Box component="li">
                                Được sử dụng để xem lại lịch sử của các phiên trước đó.
                            </Box>
                        </Box>
                    </Box>

                    {/* Lịch sử đặt cược */}
                    <Box>
                        <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0f172a", mb: 0.5 }}>
                            Lịch sử đặt cược
                        </Typography>
                        <Box component="ul" sx={{ pl: 2.5, m: 0, color: "#334155", fontSize: "13.5px", lineHeight: 1.6 }}>
                            <Box component="li">
                                Được sử dụng để xem lại lịch sử đặt cược của người chơi.
                            </Box>
                        </Box>
                    </Box>

                    {/* Tự động bẻ cược */}
                    <Box>
                        <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0f172a", mb: 0.5 }}>
                            Tự động bẻ cược
                        </Typography>
                        <Box component="ul" sx={{ pl: 2.5, m: 0, color: "#334155", fontSize: "13.5px", lineHeight: 1.6 }}>
                            <Box component="li" sx={{ mb: 0.5 }}>
                                Tính năng này cho phép admin có thể thay đổi kết quả sao cho hợp lý nhất.
                            </Box>
                            <Box component="li" sx={{ mb: 0.5 }}>
                                Với tính năng này cửa nào đặt nhiều điểm hơn sẽ thua.
                            </Box>
                            <Box component="li">
                                Có thể bật/tắt tính năng.
                            </Box>
                        </Box>
                    </Box>

                    {/* Tỉ lệ bẻ cược */}
                    <Box>
                        <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0f172a", mb: 0.5 }}>
                            Tỉ lệ bẻ cược
                        </Typography>
                        <Box component="ul" sx={{ pl: 2.5, m: 0, color: "#334155", fontSize: "13.5px", lineHeight: 1.6 }}>
                            <Box component="li" sx={{ mb: 0.5 }}>
                                Là xác suất phần trăm ván đó có bẻ cược hay không.
                            </Box>
                            <Box component="li">
                                Chỉ hoạt động khi "Tự động bẻ cược" được bật.
                            </Box>
                        </Box>
                    </Box>

                    {/* Thống kê đặt cược */}
                    <Box>
                        <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#0f172a", mb: 0.5 }}>
                            Thống kê đặt cược
                        </Typography>
                        <Box component="ul" sx={{ pl: 2.5, m: 0, color: "#334155", fontSize: "13.5px", lineHeight: 1.6 }}>
                            <Box component="li">
                                Hiện danh sách người chơi đang đặt cược vào phiên hiện tại.
                            </Box>
                        </Box>
                    </Box>

                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 2, pt: 1, justifyContent: "flex-end" }}>
                <Button 
                    variant="contained" 
                    onClick={onClose} 
                    sx={{ 
                        bgcolor: "#c6574a", 
                        color: "#ffffff", 
                        fontWeight: 600, 
                        fontSize: "14px", 
                        px: 3, 
                        py: 0.8, 
                        borderRadius: "6px",
                        textTransform: "none",
                        boxShadow: "none",
                        "&:hover": {
                            bgcolor: "#b71c1c",
                            boxShadow: "none"
                        }
                    }}
                >
                    Đóng
                </Button>
            </DialogActions>
        </Dialog>
    );
}
